'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _icons = require('./icons');

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Icon = function (_React$Component) {
  _inherits(Icon, _React$Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Icon.prototype.render = function render() {
    var size = this.props.size;

    var styles = {
      width: size,
      height: size
    };

    return _react2.default.createElement(
      'svg',
      {
        className: (0, _classnames2.default)(this.props.className, 'toastr-icon'),
        xmlns: 'http://www.w3.org/2000/svg',
        preserveAspectRatio: 'xMidYMid meet',
        viewBox: '0 0 ' + this.props.size + ' ' + this.props.size,
        style: styles
      },
      (0, _icons2.default)(this.props.name)
    );
  };

  return Icon;
}(_react2.default.Component);

Icon.displayName = 'Icon';
Icon.defaultProps = {
  size: 32
};
exports.default = Icon;


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-toastr/lib/Icon.js
// module id = 508
// module chunks = 0